import React from 'react';
import OrderItemClientNote from './OrderItemClientNote';
import OrderItemStaffNote from './OrderItemStaffNote';

/** Client and host per-line item notes on order/check item rows. */
export default function OrderItemNotes({ item, sx }) {
  return (
    <>
      <OrderItemClientNote item={item} sx={sx} />
      <OrderItemStaffNote item={item} sx={sx} />
    </>
  );
}
